import React, { useEffect, useState, useRef } from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'

import { useBaseContext } from 'context/base'
import TemplateAdmin from 'component/admin/TemplateAdmin'
import { Container, Header } from 'component/template'
import SubmitButton from 'component/button/Submit'
import InvalidText from 'component/invalid/text'
import { FormSwitch } from 'component/forms'
import InfoDocument from 'component/content-form/info-document'
import {
  FormInputName,
  FormInputUrutan,
  FormSelectSection,
  FormSelectPrecontent,
  FormInputTanggal,
  FormActiveStatus,
  FormDurasi,
  FormActiveKey,
  FormSelectFeedback,
  FormGroupKecil,
  FormInputDesc,
  FormInputEndedAt,
  InfoGdrive,
  FormTextArea,
  FormSetToBeScore,
  FormSelectStudent,
} from 'component/content-form'

export default function AddContentDocument() {
  /* ========================================== Helpers ========================================= */
  const history = useHistory()
  const location = useLocation()
  const params = useParams()

  /* ====================================== Consume Context ===================================== */
  const { getRequest, postRequest} = useBaseContext()

  /* ========================================= Constants ======================================== */
  const links = [
    { url: '/kelas', name: 'Sub Mata Pelajaran' },
    { url: `/kelas/${location.state.kelasId}`, name: 'Overview' },
  ]
  const sections = location.state.sectionList ? location.state.sectionList : []

  /* ======================================= Local States ======================================= */
  const [existingContents, setExistingContents] = useState([])
  const [namaKonten, setNamaKonten]     = useState('')
  const [urutan, setUrutan]             = useState('')
  const [sectionId, setSectionId]       = useState('')
  const [preContentId, setPrecontentId] = useState('')
  const [active, setActive]             = useState(0)
  const [durasi, setDurasi]             = useState('')
  const [displayAt, setDisplayAt]       = useState('')
  const [selectDocumentSource, setSelectDocumentSource] = useState({
    useGdrive: true,
    useUpload: false,
  })
  const [feeds, setFeeds]               = useState([])
  const [feedId, setFeedId]             = useState(null)
  const [isFeedActive, setIsFeedActive] = useState(0)
  const [enableGroup, setEnableGroup]   = useState(false)
  const [maxGroup, setMaxGroup]         = useState('')
  const [descGroup, setDescGroup]       = useState('')
  const [endedAt, setEndedAt]           = useState('')
  const [description, setDescription]   = useState('')
  const [apresiasi, setApresiasi]       = useState('')
  const [rating, setRating]             = useState(1)

  const [enableGroupKey, setEnableGroupKey] = useState(false)
  const [prerequisite, setPrerequisite]     = useState('')

  // FORM FILE STATES
  const [contentSource, setContentSource]           = useState('gdrive')
  const [contentUrlGdrive, setContentUrlGdrive]     = useState('')
  const [contentUrlInternal, setContentUrlInternal] = useState('')
  const [gdriveUrl, setGdriveUrl]                   = useState('')
  const [currentFileName, setcurrentFileName]       = useState('')
  const [file, setFile]                             = useState(null)

  // FORM VALIDATION STATES
  const [isNamaInvalid, setIsNamaInvalid]         = useState(false)
  const [isUrutanInvalid, setIsUrutanInvalid]     = useState(false)
  const [isSectionInvalid, setIsSectionInvalid]   = useState(false)
  const [isFileInvalid, setIsFileInvalid]         = useState(false)
  const [isFileTypeInvalid, setIsFileTypeInvalid] = useState(false)
  const [isFileSizeInvalid, setIsFileSizeInvalid] = useState(false)
  const [isMaxGroupValid, setIsMaxGroupValid]     = useState(true)
  const [isUploading, setIsUploading]             = useState(false)
  const [toBeScore, setToBeScore]   = useState({
    isScore: false,
    isKeterampilan: false,
    isPengetahuan: false,
    selectedTypeScore: '',
    isTypeScoreActive: true,
  })
  const [selectedStudents, setSelectedStudents] = useState([])

  /* =========================================== Refs =========================================== */
  const refInputName     = useRef()
  const refSelectSection = useRef()
  const refInputUrutan   = useRef()
  const refMaxGroup      = useRef()

  /* ========================================= Functions ======================================== */
  function getExistingContentsBySelectedSection() {
    if (!sectionId) {
      setExistingContents([])
    } else {
      sections.forEach((section) => {
        if (section.id === sectionId) {
          setExistingContents(section.contents)
        }
      })
    }
  }

  async function getFeedsList() {
    const response = await getRequest('feed')
    if (response) {
      const options = response.data.map((item) => ({
        value: item.id,
        label: item.description,
      }))
      setFeeds(options)
    } else {
      console.error('ERROR', response)
    }
  }

  function handleChangeName(event) {
    setNamaKonten(event.target.value)
  }

  function handleChangeUrutan(event) {
    setUrutan(Math.abs(event.target.value))
  }

  function handleChangeSection(event) {
    setSectionId(event.target.value)
  }

  function handleChangePrecontent(event) {
    setPrecontentId(event.target.value)
  }

  function handleChangeDate(event) {
    setDisplayAt(event.target.value)
  }

  function handleChangeDurasi(event) {
    setDurasi(event.target.value)
  }

  function handleChangeActive() {
    if (active === 1) {
      setActive(0)
    }
    if (active === 0) {
      setActive(1)
    }
  }

  function handleChangeDesc(event) {
    setDescription(event.target.value)
  }

  function handleChangeEnableGroupKey() {
    if (enableGroupKey) {
      setEnableGroupKey(false)
    } else {
      setEnableGroupKey(true)
    }
  }

  function handleChangeEndedAt(event) {
    setEndedAt(event.target.value)
  }

  function handleChangeFeedback(val) {
    setFeedId(val)
  }

  function handleUseGdrive() {
    setSelectDocumentSource({
      useGdrive: true,
      useUpload: false,
    })
    setContentSource('gdrive')
  }

  function handleUseInternal() {
    setSelectDocumentSource({
      useGdrive: false,
      useUpload: true,
    })
    setContentSource('internal')
  }

  function validateFileExtension(fileName) {
    const fileExtension = fileName.split('.').pop()
    const correctExtensionList = [
      'pdf',
      'ppt',
      'pptx',
      'doc',
      'docx',
      'xls',
      'xlsx',
    ]
    let isFileValid = false

    correctExtensionList.forEach((correctExt) => {
      if (fileExtension === correctExt) {
        isFileValid = true
      }
    })

    if (isFileValid) {
      setIsFileTypeInvalid(false)
      return 'sesuai'
    } else {
      setIsFileTypeInvalid(true)
      return 'tidak sesuai'
    }
  }

  function handleFileContent(content) {
    if (typeof content === 'string') {
      setGdriveUrl(content)
      setContentUrlGdrive({ name: null, data: content, source: contentSource })
      setcurrentFileName('')
      setContentUrlInternal('')
    } else if (`${typeof content}` === 'object') {
      const check = validateFileExtension(content.name)
      if (check === 'sesuai') {
        if (content.size <= 5000000) {
          setFile(content)
          setcurrentFileName(content.name)
          setContentUrlInternal({
            name: content.name,
            data: 'internal',
            source: contentSource,
          })
          setGdriveUrl('')
          setContentUrlGdrive('')
        } else {
          setIsFileSizeInvalid(true)
        }
      }
    }
  }

  function handleFileValidation() {
    switch (contentSource) {
      case 'gdrive':
        return contentUrlGdrive
      case 'internal':
        return contentUrlInternal
      default:
        break
    }
  }

  function handleChangeEnableGroup() {
    if (enableGroup) {
      setEnableGroup(false)
      setMaxGroup('')
      setIsMaxGroupValid(true)
    } else {
      setEnableGroup(true)
      setIsMaxGroupValid(false)
    }
  }

  function handleChangeMaxGroup(event) {
    if (event.target.value) {
      const absolute = Math.abs(event.target.value)
      const integer = Math.round(absolute)
      setMaxGroup(integer)
      if (integer <= 0) {
        setIsMaxGroupValid(false)
      } else {
        setIsMaxGroupValid(true)
      }
    } else {
      setMaxGroup('')
      setIsMaxGroupValid(false)
    }
  }

  function handleChangeDescGroup(event) {
    setDescGroup(event.target.value)
  }

  function handleChangeApresiasi(event) {
    setApresiasi(event.target.value)
  }

  function handleChangeRating(value) {
    setRating(value ? 1 : 0)
  }

  function toBeScoreValidation() {
    if (toBeScore.isScore) {
      return (toBeScore.isKeterampilan === true || toBeScore.isPengetahuan === true) && toBeScore.selectedTypeScore
    }

    return true
  }

  function handleValidation() {
    const newUrutan = urutan ? Math.abs(parseInt(urutan)) : 0
    const durasiDetik = durasi * 60
    const feedback = isFeedActive === 1 ? feedId : ''
    const contents_url = handleFileValidation()

    if (
      namaKonten &&
      urutan &&
      sectionId &&
      contents_url &&
      contents_url.data &&
      isMaxGroupValid &&
      toBeScoreValidation()
    ) {
      setIsNamaInvalid(false)
      setIsSectionInvalid(false)
      setIsUrutanInvalid(false)
      setIsFileInvalid(false)
      handleSubmitForm(
        contents_url,
        namaKonten,
        durasiDetik,
        sectionId,
        newUrutan,
        active,
        displayAt,
        preContentId,
        feedback.value,
        maxGroup,
        descGroup,
        endedAt,
        description,
        apresiasi,
        rating,
      )
    } else {
      if (!isMaxGroupValid) {
        if (refMaxGroup) {
          refMaxGroup.current.focus()
        }
      }

      if (!sectionId) {
        setIsSectionInvalid(true)
        refSelectSection.current.focus()
      } else {
        setIsSectionInvalid(false)
      }

      if (!contents_url) {
        setIsFileInvalid(true)
      } else {
        setIsFileInvalid(false)
      }

      if (!contents_url.data) {
        setIsFileInvalid(true)
      } else {
        setIsFileInvalid(false)
      }

      if (!urutan) {
        setIsUrutanInvalid(true)
        refInputUrutan.current.focus()
      } else {
        setIsUrutanInvalid(false)
      }

      if (!namaKonten) {
        setIsNamaInvalid(true)
        refInputName.current.focus()
      } else {
        setIsNamaInvalid(false)
      }

      window.notification('Data belum lengkap', 'Mohon lengkapi data')

      if (!toBeScoreValidation()) {
        window.notification('Mohon', 'lengkapi juga data "Jadikan Sebagai Penilaian"')
      }
    }
  }

  async function handleSubmitForm(
    contentUrl,
    namaKonten,
    totalDurasi,
    sectionId,
    urutan,
    active,
    displayAt,
    preContentId,
    feedId,
    maxGroup,
    descGroup,
    endedAt,
    description,
    apresiasi,
    rating,
  ) {
    let form = new FormData()
    form.append('title', namaKonten)
    form.append('content_type', 4)
    form.append('section_id', sectionId)
    form.append('urutan', urutan)
    form.append('active', active)
    form.append('durasi', totalDurasi)
    form.append('contents_url', JSON.stringify(contentUrl))
    form.append('rating', rating)

    form.append('is_score', !!toBeScore.isScore)

    if (toBeScore.isScore) {
      form.append('is_keterampilan', !!toBeScore.isKeterampilan)
      form.append('is_pengetahuan', !!toBeScore.isPengetahuan)
      form.append('type_score_id', toBeScore.selectedTypeScore)
    }

    if (Array.isArray(selectedStudents) && !!selectedStudents.length) {
      selectedStudents.forEach((selectedStudent, selectedStudentIndex) => {
        form.append(`spesifik_user_id[${selectedStudentIndex}]`, selectedStudent.id)
      })
    }

    if (displayAt) {
      form.append('display_at', displayAt)
    }

    if (endedAt) {
      form.append('ended_at', endedAt)
    }

    if (description) {
      form.append('deskripsi', description)
    }

    if (preContentId) {
      form.append('precontent_id', preContentId)
    }

    if (feedId) {
      form.append('feedback', feedId)
    }

    if (enableGroup) {
      form.append('group_status', 1)
      if (maxGroup) {
        form.append('group_max', maxGroup)
      }

      if (descGroup) {
        form.append('group_description', descGroup)
      }
    }

    if (apresiasi) {
      form.append('apresiasi', apresiasi)
    }

    if (contentUrl.source === 'internal') {
      const { id }     = JSON.parse(localStorage.getItem('user'))
      const profile_id = JSON.parse(localStorage.getItem('profile')).id
      const ext        = contentUrl.name.split('.').pop()
      form.append('path', `upload/${profile_id}/classes/contents`)
      form.append('temp_name', `file-temp-${id}-${Date.now()}.${ext}`)
      form.append('file_upload', file)
    }

    setIsUploading(true)
    const response = await postRequest('contents', form)
    setIsUploading(false)
    if (response) {
      if (enableGroupKey) {
        let formkey = new FormData()
        formkey.append('description', prerequisite)
        formkey.append('content_id', response.data.id)

        const response1 = await postRequest('contentTakeAway', formkey)
        if (response1) {
          window.notification('Materi', 'berhasil ditambahkan', 'success')
          history.push(`/kelas/${location.state.kelasId}`)
        }
      } else {
        window.notification('Materi', 'berhasil ditambahkan', 'success')
        history.push(`/kelas/${location.state.kelasId}`)
      }
    } else {
      console.error('ERROR', response)
      window.notification(
        'Terjadi kesalahan',
        'Coba beberapa saat lagi',
        'error',
      )
    }
  }

  /* ========================================== Effects ========================================= */
  useEffect(() => {
    getFeedsList()
  }, [])

  useEffect(() => {
    getExistingContentsBySelectedSection()
  }, [sectionId])

  /* ========================================== Output ========================================== */
  return (
    <TemplateAdmin>
      <Container>
        <Header
          pageName="Tambah Materi Dokumen"
          linkName="Materi Dokumen"
          links={links}
        />
        
        <div className="row">
          <div className="col">
            <div className="card">
              <div className="card-header">
                <h5>
                  <i className="fas fa-file mr-1" />
                  Informasi Dokumen
                </h5>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col">
                    <form>
                      {/* Input Nama Konten */}
                      <FormInputName
                        label="Nama Dokumen"
                        placeholder="Nama Dokumen"
                        namaKonten={namaKonten}
                        handleChangeName={handleChangeName}
                        isNamaInvalid={isNamaInvalid}
                        refInputName={refInputName}
                      />

                      {/* Form Group Document */}
                      <fieldset className="form-group row mb-5">
                        <label className="col-sm-3 col-form-label">
                          <span className="mr-1">Dokumen</span>
                        </label>
                        <div className="col-sm-9 row mb-3">
                          <div className="col">
                            {/* Select Source Gdrive*/}
                            <div className="form-check">
                              <input
                                onChange={() => handleUseGdrive()}
                                className="form-check-input"
                                type="radio"
                                name="selectDokumen"
                                id="gdriveUrl"
                                defaultValue={1}
                                defaultChecked={true}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="gdriveUrl"
                              >
                                <i className="fab fa-google-drive mr-1" />
                                <span>Google Drive</span>
                              </label>
                            </div>

                            {/* Input URL Gdrive */}
                            {selectDocumentSource.useGdrive ? (
                              <div className="mb-4">
                                <InfoGdrive />
                                <input
                                  type="text"
                                  value={gdriveUrl}
                                  onChange={(event) =>
                                    handleFileContent(event.target.value)
                                  }
                                  className="form-control my-3"
                                  placeholder="Format link: https://drive.google.com/file/d/xyz"
                                />
                                {gdriveUrl ? (
                                  <iframe
                                    src={`${gdriveUrl}/preview`}
                                    style={{
                                      width: '100%',
                                      height: '100vh',
                                      border: 'none',
                                      backgroundColor: '#ddd',
                                    }}
                                  />
                                ) : null}
                              </div>
                            ) : null}

                            {/* Select Source Internal */}
                            <div className="form-check">
                              <input
                                onChange={() => handleUseInternal()}
                                className="form-check-input"
                                type="radio"
                                name="selectDokumen"
                                id="internalFile"
                                defaultValue={0}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="internalFile"
                              >
                                <i className="fas fa-file mr-1" />
                                <span>Upload file</span>
                                {/* <span className="ml-1">(.pdf, .ppt, .doc, .xls)</span> */}
                              </label>
                            </div>

                            {/* Input File Document */}
                            {selectDocumentSource.useUpload && <InfoDocument />}
                            {selectDocumentSource.useUpload ? (
                              <div className="custom-file my-3">
                                <input
                                  type="file"
                                  accept=".pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx"
                                  onChange={(event) =>
                                    handleFileContent(event.target.files[0])
                                  }
                                  className="custom-file-input"
                                  id="inputFileVideo"
                                />
                                <label
                                  className="custom-file-label"
                                  htmlFor="inputFileVideo"
                                >
                                  {currentFileName
                                    ? currentFileName
                                    : 'Pilih file: pdf/ppt/word/excel'}
                                </label>
                                {isFileTypeInvalid ? (
                                  <label className="col small form-text text-danger">
                                    Hanya mendukung file: pdf, powerpoint, word,
                                    dan excel
                                  </label>
                                ) : null}
                              </div>
                            ) : null}
                            {isFileInvalid ? (
                              <InvalidText name={'Dokumen'} />
                            ) : null}
                            {isFileSizeInvalid ? (
                              <label className="col small form-text text-danger mt-3">
                                Ukuran file melebihi 5 mb.
                              </label>
                            ) : null}
                          </div>
                        </div>
                      </fieldset>

                      {/* Input Urutan */}
                      <FormInputUrutan
                        urutan={urutan}
                        handleChangeUrutan={handleChangeUrutan}
                        isUrutanInvalid={isUrutanInvalid}
                        refInputUrutan={refInputUrutan}
                      />

                      {/* Input deskripsi */}
                      <FormInputDesc
                        description={description}
                        handleChangeDesc={handleChangeDesc}
                      />

                      {/* Input Apresiasi */}
                      <FormTextArea
                        id="formInputApresiasi"
                        label="Apresiasi"
                        placeholder="Apresiasi/pesan setelah siswa menyelesaikan materi (opsional)"
                        className="mb-5"
                        value={apresiasi}
                        handleChange={handleChangeApresiasi}
                      />

                      {/* Select Section */}
                      <FormSelectSection
                        sections={sections}
                        handleChangeSection={handleChangeSection}
                        isSectionInvalid={isSectionInvalid}
                        existingSectionId={sectionId}
                        refSelectSection={refSelectSection}
                      />

                      {/* Select Precontent */}
                      <FormSelectPrecontent
                        existingContents={existingContents}
                        handleChangePrecontent={handleChangePrecontent}
                      />

                      {/* Input Tanggal Ditampilkan */}
                      <FormInputTanggal
                        existingDisplayAt={displayAt}
                        handleChangeDate={handleChangeDate}
                      />

                      {/* Input ended at */}
                      <FormInputEndedAt
                        endedAt={endedAt}
                        handleChangeEndedAt={handleChangeEndedAt}
                      />

                      {/* Input Durasi */}
                      <FormDurasi
                        existingDurasi={durasi}
                        handleChangeDurasi={handleChangeDurasi}
                      />

                      {/* Rating */}
                      <FormSwitch
                        id="formRating"
                        label="Rating Materi"
                        value={rating}
                        handleChange={handleChangeRating}
                      />

                      {/* Select Feedback */}
                      <FormSelectFeedback
                        existingFeedId={feedId}
                        existingFeeds={feeds}
                        isFeedActive={isFeedActive}
                        setIsFeedActive={setIsFeedActive}
                        handleChangeFeeds={handleChangeFeedback}
                        getFeedList={getFeedsList}
                      />

                      {/* Swicth Group Kecil */}
                      <FormGroupKecil
                        enableGroup={enableGroup}
                        handleChangeEnableGroup={handleChangeEnableGroup}
                        maxGroup={maxGroup}
                        descGroup={descGroup}
                        handleChangeMaxGroup={handleChangeMaxGroup}
                        handleChangeDescGroup={handleChangeDescGroup}
                        isMaxGroupValid={isMaxGroupValid}
                        refMaxGroup={refMaxGroup}
                      />

                      {/* Select Specific Students */}
                      <FormSelectStudent 
                        selectedStudents={selectedStudents}
                        setSelectedStudents={setSelectedStudents}
                        subMapelId={params?.kelasId}
                        isWithCheckSavedOrNot={false}
                      />

                      {/* Select To Be Score Or Not */}
                      <FormSetToBeScore
                        value={toBeScore}
                        handleChange={setToBeScore}
                      />

                      {/* Select Status */}
                      <FormActiveStatus
                        existingStatus={active}
                        handleChangeStatus={handleChangeActive}
                      />

                      <FormActiveKey
                        enableGroupKey={enableGroupKey}
                        handleChangeEnableGroupKey={handleChangeEnableGroupKey}
                        prerequisite={prerequisite}
                        setPrerequisite={setPrerequisite}
                      />

                      <div className="form-group">
                        <button
                          onClick={() =>
                            history.push(`/kelas/${location.state.kelasId}`)
                          }
                          type="button"
                          className="btn btn-outline-danger has-ripple mr-2"
                        >
                          Kembali
                        </button>
                        {isUploading ? (
                          <button
                            disabled={true}
                            type="button"
                            className="btn btn-success mr-2"
                          >
                            <span
                              className="spinner-border spinner-border-sm mr-1"
                              role="status"
                            />
                            <span>Simpan</span>
                          </button>
                        ) : (
                          <SubmitButton
                            onClick={() => handleValidation()}
                            text="Simpan"
                          />
                        )}
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </TemplateAdmin>
  )
}
